import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_BEGIN,
  MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_SUCCESS,
  MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_FAILURE,
  MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function fetchValidationItemData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/getValidationItemData?opcoId=${args.opcoId}&productId=${args.productId}`, null, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
           if (res.data && res.data.result === "Failed" && res.data.data === null && res.data.errorMessage) { //COT-10152
            dispatch({
              type: MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_FAILURE,
              data: { error: res.data.errorMessage },
            });
            return reject(res.data); // Optionally reject if you want to handle in UI
          }
          dispatch({
            type: MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_FAILURE,
            data: { error: errorMsg },
          });
          if(err && err.response && err.response.status == '404' && err.response.data && err.response.data.description.includes('special')) {
            reject({
              isSpecialItem: true,
              message: 'Sub/Not-Suit-Sub item should not be a special item.'
            })
          }else {
            reject(err)
          }
        },
      );
    });

    return promise;
  };
}

export function dismissFetchValidationItemDataError() {
  return {
    type: MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_DISMISS_ERROR,
  };
}

export function useFetchValidationItemData() {
  const dispatch = useDispatch();

  const { validationItemData, fetchValidationItemDataPending, fetchValidationItemDataError } = useSelector(
    state => ({
      validationItemData: state.manageSubs.validationItemData,
      fetchValidationItemDataPending: state.manageSubs.fetchValidationItemDataPending,
      fetchValidationItemDataError: state.manageSubs.fetchValidationItemDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchValidationItemData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchValidationItemDataError());
  }, [dispatch]);

  return {
    validationItemData,
    fetchValidationItemData: boundAction,
    fetchValidationItemDataPending,
    fetchValidationItemDataError,
    dismissFetchValidationItemDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchValidationItemDataPending: true,
        fetchValidationItemDataError: null,
      };

    case MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        validationItemData: action.data,
        fetchValidationItemDataPending: false,
        fetchValidationItemDataError: null,
      };

    case MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchValidationItemDataPending: false,
        fetchValidationItemDataError: action.data.error,
      };

    case MANAGE_SUBS_FETCH_VALIDATION_ITEM_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchValidationItemDataError: null,
      };

    default:
      return state;
  }
}
